<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h1>404</h1>
                <p>Page not found</p>
            </v-col>
        </v-row>
    </v-container>
</template>